/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Peruuta',
    CONFIRM: 'Vahvista',
    SAVE: 'Tallenna'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Linkki',
    SOCIAL_NETWORK: 'Sosiaalinen verkostoituminen',
    USERNAME: 'Käyttäjän nimi'
  },
  LABEL: {
    CREATE_LINK: 'Lisää sosiaalinen verkosto',
    EDIT_LINK: 'Muokkaa sosiaalista verkostoa',
    INACTIVATE_LINK: 'Poista sosiaalinen verkosto',
    INACTIVATE_LINK_MODAL_TITLE: 'Poista sosiaalinen verkosto',
    LINK: 'Linkki',
    SOCIAL_NETWORK: 'Sosiaalinen verkostoituminen',
    USERNAME: 'Käyttäjän nimi'
  },
  SENTENCE: {
    ERROR: 'Virhe',
    INACTIVATE_LINK_TEXT: 'Haluatko varmasti poistaa sosiaalisen verkoston?',
    NO_ROWS_LINKS: 'Ei sosiaalista mediaa'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Sosiaalinen verkosto onnistuneesti eliminoitu',
    LINKS_DETAILS_SAVED: 'Sosiaalinen verkosto onnistuneesti tallennettu',
    LINKS_DETAILS_UPDATED: 'Sosiaalinen verkosto onnistuneesti päivitetty',
    SUCCESS: 'Menestys'
  },
  TOOLTIP: {
    LINK: 'Linkki',
    SOCIAL_NETWORK: 'Sosiaalinen verkostoituminen',
    USERNAME: 'Käyttäjän nimi'
  }
};
